import Swiper from 'swiper';
import leadZero from '@/scripts/utils/lead-zero';
import DLAnimate from 'dl-animate/dist/dl-animate-module';
import { DOCUMENT_ELEMENT } from '@/scripts/constants';
import 'swiper/dist/css/swiper.css';
import './swiper-slider.scss';

export default function initSwiperSlider(props) {
  const {
    slidesPerView = 3,
    spaceBetween = 30,
    breakpoints = null,
    speed = 750,
    selector,
    pagination = false,
    autoplay = false,
    nested = false,
    loop = false,
    paginationType = 'fraction',
    loopedSlides = 1,
    swiperTitle = null,
  } = props;
  return $(`[data-slider="${selector}"]`).each((i, el) => {
    const $container = $(el).closest('[data-role*="slider-container"]');
    const $controls = $container.find('[data-role*="controls"]');
    const $slides = $container.find('.swiper-slide');
    const $pagination = $container.find('[data-role*="pagination"]');
    const $progress = $container.find('[data-role*="progress"]');
    const $line = $progress.find('.line');
    const { seasonFilters } = el.dataset;

    if (!$slides.length) return false;

    const swiperConfig = {
      preloadImages: false,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: Math.max(2, slidesPerView),
      },
      keyboard: {
        enabled: true,
      },
      slidesPerView,
      spaceBetween,
      breakpoints,
      navigation: {
        nextEl: $controls.find('.swiper-button-next')[0],
        prevEl: $controls.find('.swiper-button-prev')[0],
      },
      pagination: pagination && {
        el: $pagination[0],
        type: paginationType,
        formatFractionCurrent: number => leadZero(number),
        formatFractionTotal: number => leadZero(number),
        renderFraction(currentClass, totalClass) {
          return `<span class="${currentClass}"></span>` +
            `<span class="${totalClass}"></span>`;
        },
        dynamicBullets: true,
        dynamicMainBullets: 3,
        clickable: true,
      },
      parallax: !!el.querySelector('[data-role*="swiper-parallax"]'),
      simulateTouch: false,
      speed,
      autoplay,
      nested,
      loop,
      loopedSlides,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      init: false,
    };

    if (swiperTitle) {
      $container.find('[data-role*="swiper-title"]').text(swiperTitle);
    }
    const swiper = new Swiper(el, { ...swiperConfig });
    const $titleContainer = $container.find('[data-role*="slide-title"]');
    const animate = new DLAnimate();

    const waiting = () => {
      $line
        .css({
          'animation-duration': `${autoplay.delay}ms`,
        });
      $progress
        .addClass('is-waiting')
        .removeClass('is-sliding');
    };

    const sliding = () => {
      $line
        .css({
          'animation-duration': `${speed}ms`,
        });
      $progress
        .addClass('is-sliding')
        .removeClass('is-waiting');
    };

    waiting();

    swiper
      .on('init', () => {
        const { title } = $slides[swiper.activeIndex].dataset;
        if (title) {
          $container.find('[data-role*="slide-title"]').text(title);
        }
      })
      .on('transitionStart', () => {
        const { title } = $slides[swiper.activeIndex].dataset;
        if (title) {
          animate.hide($titleContainer[0], {
            name: 'slide-title',
            afterLeave() {
              $titleContainer.text(title);
              animate.show($titleContainer[0], {
                name: 'slide-title',
              });
            },
          });
        }
        $slides.addClass('is-animated');
        if (pagination) {
          sliding();
        }
      })
      .on('transitionEnd', () => {
        $slides.removeClass('is-animated');
        if (pagination) {
          waiting();
        }
      });

    swiper.init();

    if (seasonFilters) {
      const $shadowSlides = $slides.map((index, slide) => slide);
      const $wrapper = $(el).find('.swiper-wrapper');
      DOCUMENT_ELEMENT.addEventListener('filterseason', ({ detail }) => {
        $wrapper.children().remove();
        $wrapper.append($shadowSlides.filter((index, slide) => slide.dataset.season === detail.season));
        swiper.update();
      });
    }

    return swiper;
  });
}



// WEBPACK FOOTER //
// ./scripts/blocks/swiper-slider/swiper-slider.js